import { RouterModule, Routes } from '@angular/router';
import { NgModule } from '@angular/core';
import { AppComponent } from './app.component';
import { BrowserModule } from '@angular/platform-browser';
import { FormsModule } from '@angular/forms';

import { AboutComponent } from './components/about/about.component';
import { BlogComponent } from './components/blog/blog.component';
import { CareersComponent } from './components/careers/career.component';
import { CaseStudiesComponent } from './components/case-studies/case-studies.component';
import { ContactComponent } from './components/contact/contact.component';
import { DateTimeToolComponent } from './components/tools/date-time-tool/date-time-tool.component';
import { DocumentationComponent } from './components/documentation/documentation.component';
import { EventsComponent } from './components/events/events.component';
import { FaqsComponent } from './components/faqs/faqs.component';
import { HomeComponent } from './components/home/home.component';
import { ImpressumComponent } from './components/impressum/impressum.component';
import { JobDetailsComponent } from './components/careers/job-details/job-details.component';
import { NewsComponent } from './components/news/news.component';
import { NewsletterSubscriptionComponent } from './components/newsletter-subscription/newsletter-subscription.component';
import { NewsletterUnsubscriptionComponent } from './components/newsletter-unsubscription/newsletter-unsubscription.component';
import { OffersComponent } from './components/offers/offers.component';
import { OffersDetailComponent } from './components/offers-detail/offers-detail.component';
import { PartnersComponent } from './components/partners/partners.component';
import { PhotoGalleryComponent } from './components/photo-gallery/photo-gallery.component';
import { PrivacyPolicyComponent } from './components/privacy-policy/privacy-policy.component';
import { ProductsComponent } from './components/products/products.component';
import { ProductsDetailComponent } from './components/products-detail/products-detail.component';
import { SocialComponent } from './components/social/social.component';
import { SupportComponent } from './components/support/support.component';
import { ToolsComponent } from './components/tools/tools.component';
import { AgeCalculatorComponent } from './components/tools/age-calculator/age-calculator.component';
import { DateCalculatorComponent } from './components/tools/date-calculator/date-calculator.component';
import { DateTimeCalculatorComponent } from './components/tools/date-time-calculator/date-time-calculator.component';
import { SitemapComponent } from './components/sitemap/sitemap.component';
import { BmiCalculatorComponent } from './components/tools/bmi-calculator/bmi-calculator.component';
import { CalorieCalculatorComponent } from './components/tools/calorie-calculator/calorie-calculator.component';
import { DiscountCalculatorComponent } from './components/tools/discount-calculator/discount-calculator.component';

export const routes: Routes = [
    { path: '', component: HomeComponent },
    { path: 'about', component: AboutComponent },
    { path: 'blog', component: BlogComponent },
    { path: 'careers', component: CareersComponent },
    { path: 'case-studies', component: CaseStudiesComponent },
    { path: 'contact', component: ContactComponent },
    { path: 'documentation', component: DocumentationComponent },
    { path: 'events', component: EventsComponent },
    { path: 'faqs', component: FaqsComponent },
    { path: 'impressum', component: ImpressumComponent },
    { path: 'jobs/:id', component: JobDetailsComponent },
    { path: 'news', component: NewsComponent },
    { path: 'newsletter/sub', component: NewsletterSubscriptionComponent },
    { path: 'newsletter/unsub', component: NewsletterUnsubscriptionComponent },
    { path: 'partners', component: PartnersComponent },
    { path: 'photo-gallery', component: PhotoGalleryComponent },
    { path: 'privacy-policy', component: PrivacyPolicyComponent },
    //{ path: 'offers', component: OffersComponent },
    //{ path: 'offers/:id', component: OffersDetailComponent },
    { path: 'products', component: ProductsComponent },
    { path: 'products/:id', component: ProductsDetailComponent },
    { path: 'sitemap', component: SitemapComponent },
    { path: 'social', component: SocialComponent },
    { path: 'support', component: SupportComponent },
    { path: 'tools', component: ToolsComponent },
    { path: 'tools/age-calculator', component: AgeCalculatorComponent },
    { path: 'tools/bmi-calculator', component: BmiCalculatorComponent },
    { path: 'tools/calorie-calculator', component: CalorieCalculatorComponent },
    { path: 'tools/date-calculator', component: DateCalculatorComponent },
    { path: 'tools/date-time-calculator', component: DateTimeCalculatorComponent },
    { path: 'tools/date-time-tools', component: DateTimeToolComponent },
    { path: 'tools/discount-calculator', component: DiscountCalculatorComponent },
];

@NgModule({
    imports: [
        BrowserModule, FormsModule,
        RouterModule.forRoot(
            routes,
            { useHash: true, enableTracing: true }  // <-- debugging purposes only
        )
    ],
    declarations: [
    ],
})
export class AppRoutingModule { }
